import React, { useState } from "react"
import { connect } from "react-redux"
import { editMenuItem, setSelectedFeature } from "store/actions"

const MenuFeaturesListNameToggle = ({
  feature,
  editMenuItem,
  setSelectedFeature,
  isEventFeature,
}) => {
  const [inputValue, setInputValue] = useState(feature.label)

  const handleSaveName = () => {
    if (inputValue !== feature.label) {
      editMenuItem({
        data: {
          delete_image: 0,
          image_file: null,
          label: inputValue,
          menu_item_id: feature.id,
          status: feature.status,
        },
        type: isEventFeature ? "event" : "landing",
      })
      // setSelectedFeature({ ...feature, label: inputValue })
    }
  }
  return (
    <div>
      <p style={{ marginBottom: "5px", fontSize: "10px" }}>
        {feature.placeholder}
      </p>
      <input
        type="text"
        value={inputValue}
        onChange={event => setInputValue(event.target.value)}
        style={{
          background: "transparent",
          borderWidth: "0px 0px 1px",
          outline: "none",
        }}
        onBlur={handleSaveName}
      />
    </div>
  )
}

const mapDispatchToProps = dispatch => ({
  editMenuItem: values => dispatch(editMenuItem(values)),
  setSelectedFeature: value => dispatch(setSelectedFeature(value)),
})

export default connect(null, mapDispatchToProps)(MenuFeaturesListNameToggle)
